import React, {Fragment} from 'react'
// import Config from '../launch/config'

import './css/score-info.css'

const ScoreInfo = () => {
    return (
        <Fragment>
            <div className="score-info__preview">
                <img
                    alt="resource"
                    className="score-info__preview-img"
                    src={`${process.env.PUBLIC_URL}/img/score.png`}
                />
            </div>
            <div className="score-info__description">
                <h1 className="modal-heading">Game Score</h1>
                <p>
                    The game score which contributes to your overall career
                    score.
                </p>
            </div>
        </Fragment>
    )
}

export default ScoreInfo
